import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import combineSelectors from 'utils/combineSelectors';
import { templateStatus } from 'reducers/templates/selectors';
import { modelWorkingState } from 'reducers/models/selectors';
import { addIntlProps } from 'utils/recompose';
import { injectIntl } from 'react-intl';
import messages from './messages';
import { removeTemplateFromWorkingState } from 'reducers/models/actions';

const mapStateToProps = combineSelectors({
  modelWorkingState,
  templateStatus,
});

export const removeTemplate = ({
  removeTemplateFromWorkingState,
  modelId,
  templateId,
}) => () => removeTemplateFromWorkingState(modelId, templateId);

export default compose(
  connect(mapStateToProps, {
    removeTemplateFromWorkingState,
  }),
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['removeString'],
  }),
  withHandlers({ removeTemplate }),
);
